import { Button, Card, Group, Image, MantineTheme, Stack, Text, Title } from "@mantine/core";
import { Entity, EntityDefinition, getGoogleMapsStreetViewImage, latLng, RecordGroupManager, useEntityUI, ValuesRecord } from "@mcurros2/microm";
import { PersonalTiendas } from "./PersonalTiendas";

export function GestionTiendasPersonalViewInfoWindowRenderer(
    record: ValuesRecord,
    position: latLng,
    groupManager: RecordGroupManager,
    infoWindow: google.maps.InfoWindow,
    UIAPI: ReturnType<typeof useEntityUI>,
    theme: MantineTheme,
    entity: Entity<EntityDefinition>
) {

    const tienda_id = record[1] as string;
    const cadena = record[3] as string;
    const canales = record[4] as string;
    const tienda = record[5] as string;

    const PersonalTiendas = entity as PersonalTiendas;

    const group = groupManager.getGroupByLocation(position);

    if (group) {
        return (
            <Card withBorder>
                <Stack spacing="xs" mb="xs">
                    {group.records.map(
                        ({ recordValue: rec }, index) => <Group key={`grp_${rec[1]}`}>
                            <Title order={5}>{`${rec[4]} - ${rec[5]}`}</Title>
                            <Button size="xs" onClick={async () => {
                                await UIAPI.handleExecuteAction(
                                    PersonalTiendas.def.clientActions.ACTVerTienda,
                                    [{ 'c_tienda_id': rec[1] }]
                                );
                            }} >Ver</Button>
                        </Group>
                    )
                    }
                    <Group>
                        <Button size="xs" variant="light" onClick={() => {
                            infoWindow.close();
                        }}>Cerrar</Button>
                    </Group>
                </Stack>
            </Card>
        )
    }
    else {
        return (
            <Card withBorder padding="xs">
                <Stack spacing="0.5rem">
                    <Image width={350} height={120} src={getGoogleMapsStreetViewImage(position, 350, 200, 150)} mx="auto" />
                    <Title order={4}>{`${tienda}`}</Title>
                    <Group spacing="xs">
                        <Text weight={500} size="sm">Cadena: </Text>
                        {cadena}
                    </Group>
                    <Group spacing="xs">
                        <Text weight={500} size="sm">Canales: </Text>
                        {canales}
                    </Group>
                    <Group position="right">
                        <Button size="xs" onClick={async () => {
                            await UIAPI.handleExecuteAction(
                                PersonalTiendas.def.clientActions.ACTVerTienda,
                                [{ 'c_tienda_id': tienda_id }]
                            );
                        }} >Ver</Button>
                        <Button size="xs" variant="light" onClick={() => {
                            infoWindow.close();
                        }}>Cerrar</Button>
                    </Group>
                </Stack>
            </Card>
        )
    }
}